import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import '@web/shared-digital-library/icons/svg-originals/plus-around.svg';
var RegularMediaArtDirection = function RegularMediaArtDirection() {
  return import('~/components/atoms/Editorial/RegularMediaArtDirection.vue');
};
export default {
  name: 'MediaAndOverlay',
  components: {
    RegularMediaArtDirection: RegularMediaArtDirection
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    srcsets: {
      type: Object,
      required: true
    },
    videoMp4: {
      type: String,
      default: ''
    },
    videoWebm: {
      type: String,
      default: ''
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    iconPlayColor: {
      type: String,
      default: '#ffffff'
    },
    hasOverlay: {
      type: Boolean,
      default: false
    },
    ratioImg: {
      type: String,
      default: '1:1'
    },
    componentType: {
      type: String,
      default: 'default'
    },
    url: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: null
    },
    overlayType: {
      type: String,
      default: 'plain',
      validator: function validator(value) {
        return ['plain', 'gradient'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      isPaused: !this.autoPlay
    };
  },
  computed: {
    href: function href() {
      return this.componentType === 'link' ? 'href' : '';
    }
  }
};